import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex flex-col gap-2 mt-4" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("label", null, "Select your prefered time zone", -1);
import { ref } from 'vue';
import Dropdown from 'primevue/dropdown';
import { useUserPreferences, useToastNotifications, useHandleError } from '@apparatix/composables';
export default /*#__PURE__*/ _defineComponent({
    __name: 'TimezoneSettings',
    props: {
        zones: {},
        selected: {}
    },
    setup(__props) {
        const props = __props;
        const selectedTz = ref(props.selected ?? '');
        const { updatePreference } = useUserPreferences();
        const { showSuccess } = useToastNotifications();
        const errorHandler = useHandleError();
        const onValueChange = async (value) => {
            if (value !== props.selected) {
                const result = await updatePreference({ updateTimezone: value });
                if (result.success && result.updatedTimezone) {
                    showSuccess('Timezone successfully updated');
                }
                else {
                    errorHandler.handleError({ message: 'Error saving timezone', logToSentry: true });
                }
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                _createElementVNode("div", null, [
                    _createVNode(_unref(Dropdown), {
                        modelValue: selectedTz.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((selectedTz).value = $event)),
                        options: props.zones,
                        placeholder: "Select timezone",
                        onChange: _cache[1] || (_cache[1] = e => onValueChange(e.value))
                    }, null, 8, ["modelValue", "options"])
                ])
            ]));
        };
    }
});
